import { useQuery } from "@tanstack/react-query";

import { getAllUsers } from "../services/admin.service";
import Loader from "../ui/Spinner.component";
import UsersTable from "../ui/uiElements/UsersTable.component";
import { Alert } from "react-bootstrap";
import ErrorPage from "../ui/ErrorPage.component";

function Users() {
  const {
    isLoading,
    data: users,
    error,
  } = useQuery({
    queryKey: ["allUsers"],
    queryFn: getAllUsers,
  });

  if (isLoading) return <Loader />;

  if (error) return <ErrorPage errorCode="500" description="Something went wrong , please try again later" />;

  return (
    <div>
      <h3>All Users</h3>
      <hr />
      {users.length === 0 ? <Alert variant="dark">No users found</Alert> : <UsersTable users={users} type="allUsers" />}
    </div>
  );
}

export default Users;
